export default __webpack_public_path__ + "pgnv-assets/47fb2c28cd6941656d1020997f423633.svg";